export const shorthandMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function filterMobilePrinters(item: { printerName: string }) {
  return item.printerName.includes('MP');
}

export function getLocationRef(location:{ storeRef: string, locationRef: string }) {
  return `${location.storeRef} - ${location.locationRef}`;
}

export function getPrinterName(printer:{ printerName: string }) {
  return printer.printerName;
}

/* istanbul ignore next */ 
export function generateUniqueId(){
  let dt = new Date().getTime();
  const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 || 0;
    dt = Math.floor(dt / 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3 || 0x8)).toString(16);
  });
  return id;
}

/* istanbul ignore next */ 
export function lockCanvas(active:boolean | undefined) {
  const HTML = document.getElementsByTagName('html')[0];
  if (active) {
    HTML.classList.add('lock');
  } else if (HTML.classList.contains('lock')) {
    HTML.classList.remove('lock');
  }
}

export function preventDuplicate(arr:[], label:string) {
  function filterArr(item:{ label: string }) {
    return item.label !== label;
  }
  return arr.filter(filterArr);
}

export function removeById(arr:[], id:string) {
  function filterArr(item:{ id: string }) {
    return item.id !== id;
  }
  return arr.filter(filterArr);
}

export function timeFormatter(startDate:Date, endDate:Date) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const timeDifference = Number(endDate) - Number(startDate);

  if (timeDifference < 0) {
    return false;
  }

  const minutes = Math.floor((timeDifference % hour) / minute);
  const seconds = Math.floor((timeDifference % minute) / second);

  const formatter = [];
  if (minutes > 0) {
    formatter.push(`${+minutes}:`);
  }
  if (seconds < 10) {
    formatter.push(`0${seconds}`);
  } else {
    formatter.push(`${seconds}`);
  }

  return formatter.join('');
}

export function capitalise(str:string) {
  const arr = str.toLowerCase().split(' ');
  function capitaliseWord(word:string) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  return arr.map(capitaliseWord).join(' ');
}